// Selezione con il mouse: Ctrl/Cmd+clic = aggiungi/togli, Shift+clic = intervallo dall'ultimo cliccato.
export function modSelect(e, id, order, lastRef, toggleOne, addMany) {
  if (!(e.ctrlKey || e.metaKey || e.shiftKey)) return false;
  e.preventDefault();
  e.stopPropagation();
  const last = lastRef.current;
  if (e.shiftKey && last && order.includes(last) && order.includes(id)) {
    const a = order.indexOf(last), b = order.indexOf(id);
    addMany(order.slice(Math.min(a, b), Math.max(a, b) + 1));
  } else {
    toggleOne(id);
  }
  lastRef.current = id;
  return true;
}

// Evita la selezione del testo durante Shift+clic.
export const noShiftTextSelect = (e) => { if (e.shiftKey || e.ctrlKey || e.metaKey) e.preventDefault(); };
